<template>
  <div id="section-to-print">
    <!-- /////////////////////////////////START OF DIREKSI//////////////////////////////////////////// -->
    <div class="row add-page-break-after" v-if="diklats">
      <div class="col-12">
        <div class="p-3 mb-3">
          <div class="row">
            <div class="col-12">
              <h4 class="header-title">
                <strong>DATA DIKLAT PEGAWAI TAHUN {{ printTahun() }}</strong>
              </h4>
              <table class="table">
                <thead>
                  <tr class="center-top-text">
                    <th rowspan="2" style="width: 2%">No</th>
                    <th rowspan="2">Bulan</th>
                    <th rowspan="2" colspan="2" style="min-width: 80px">
                      Penyelenggara Diklat/Narasumber Diklat<br />Lembaga
                    </th>
                    <th rowspan="2">Jumlah<br />Peserta</th>

                    <th rowspan="2" colspan="2" style="min-width: 100px">
                      Nama Peserta
                    </th>
                    <th rowspan="2">Jabatan</th>
                    <th colspan="2">Ada atau<br />Tidak<br />Sertifikat</th>
                    <th rowspan="2" colspan="2">Biaya Diklat</th>
                    <th rowspan="2">Materi Diklat</th>
                  </tr>
                  <tr class="center-top-text">
                    <th style="width: 3%">Ada</th>
                    <th style="width: 3%">Tidak</th>
                  </tr>
                </thead>

                <template
                  v-for="(monthData, rowPerBulan) in filteredData"
                  :key="rowPerBulan"
                >
                  <template
                    v-for="(row, rowPerDiklat) in monthData.diklatPerMonth"
                    :key="rowPerDiklat"
                  >
                    <tr>
                      <td
                        class="center-top-text no-border-bottom no-border-top"
                        style="border: 1px solid #000"
                        v-if="rowPerDiklat !== 0"
                      >
                        <!-- nomor -->
                      </td>
                      <td
                        class="center-top-text border-top no-border-bottom"
                        style="border: 1px solid #000"
                        v-if="rowPerDiklat === 0"
                      >
                        {{ rowPerBulan + 1 }}
                      </td>

                      <td
                        class="center-top-text border-top no-border-bottom"
                        style="border: 1px solid #000"
                        v-if="rowPerDiklat === 0"
                      >
                        {{ printBulanNama(row.tgl) }}
                      </td>
                      <td
                        class="center-top-text no-border-bottom no-border-top"
                        style="border: 1px solid #000"
                        v-if="rowPerDiklat !== 0"
                      >
                        <!-- nomorBulan -->
                      </td>

                      <td
                        style="border: 1px solid #000; min-width: 20px"
                        class="no-border-right less-padding-right border-top no-border-bottom"
                        v-if="rowPerDiklat === 0"
                      >
                        {{ rowPerDiklat + 1 }}
                      </td>
                      <!-- :rowspan="row.jml_peserta" -->

                      <td
                        class="no-border-right less-padding-right no-border-bottom"
                        style="border: 1px solid #000; min-width: 20px"
                        v-if="rowPerDiklat !== 0"
                      >
                        {{ rowPerDiklat + 1 }}
                      </td>

                      <td
                        style="border: 1px solid #000"
                        class="no-border-left less-padding-left no-border-bottom"
                      >
                        {{ row.penyelenggara }}
                      </td>

                      <td
                        class="center-top-text border-top no-border-bottom"
                        style="border: 1px solid #000"
                      >
                        {{ row.jml_peserta }}
                      </td>

                      <td
                        style="border: 1px solid #000; min-width: 20px"
                        class="no-border-right less-padding-right"
                      >
                        1
                      </td>

                      <td
                        style="border: 1px solid #000"
                        class="no-border-left less-padding-left"
                      >
                        {{ row.diklat_pegawais[0]?.pegawai.nama }}
                      </td>
                      <td style="border: 1px solid #000">
                        {{ row.diklat_pegawais[0]?.jabatan_print }}
                      </td>

                      <td
                        class="center-top-text border-top no-border-bottom"
                        style="border: 1px solid #000"
                        v-if="rowPerDiklat === 0"
                      >
                        <div v-if="row.sertifikat">&#10003;</div>
                        <div v-else>&nbsp;</div>
                      </td>
                      <td
                        class="center-top-text border-top no-border-bottom"
                        style="border: 1px solid #000"
                        v-if="rowPerDiklat === 0"
                      >
                        <div v-if="row.sertifikat">&nbsp;</div>
                        <div v-else>&#10003;</div>
                      </td>
                      <td
                        class="center-top-text no-border-bottom"
                        style="border: 1px solid #000"
                        v-if="rowPerDiklat !== 0"
                      >
                        <div v-if="row.sertifikat">&#10003;</div>
                        <div v-else>&nbsp;</div>
                      </td>
                      <td
                        class="center-top-text no-border-bottom"
                        style="border: 1px solid #000"
                        v-if="rowPerDiklat !== 0"
                      >
                        <div v-if="row.sertifikat">&nbsp;</div>
                        <div v-else>&#10003;</div>
                      </td>

                      <td
                        style="border: 1px solid #000; width: 2px"
                        class="no-border-right less-padding-right left-top-text center-top-text border-top no-border-bottom"
                        v-if="rowPerDiklat === 0"
                      >
                        Rp.
                      </td>

                      <td
                        style="border: 1px solid #000"
                        class="no-border-left less-padding-left right-top-text border-top no-border-bottom"
                        v-if="rowPerDiklat === 0"
                      >
                        {{ formatNumber(row.biaya) }}
                      </td>

                      <td
                        style="border: 1px solid #000; width: 2px"
                        class="no-border-right less-padding-right left-top-text center-top-text no-border-bottom"
                        v-if="rowPerDiklat !== 0"
                      >
                        Rp.
                      </td>

                      <td
                        style="border: 1px solid #000"
                        class="no-border-left less-padding-left right-top-text no-border-bottom"
                        v-if="rowPerDiklat !== 0"
                      >
                        {{ formatNumber(row.biaya) }}
                      </td>

                      <td
                        style="border: 1px solid #000"
                        class="border-top no-border-bottom"
                        v-if="rowPerDiklat === 0"
                      >
                        {{ row.materi }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        class="no-border-bottom"
                        v-if="rowPerDiklat !== 0"
                      >
                        {{ row.materi }}
                      </td>
                    </tr>
                    <tr
                      v-for="(
                        peserta, pesertaIndex
                      ) in row.diklat_pegawais.slice(1)"
                      :key="`peserta-${rowPerDiklat}-${pesertaIndex}`"
                      :class="{
                        'page-break': isPageBreak(peserta.indexUrutanPegawai),
                      }"
                    >
                      <!-- :class="{
                        'page-break': isPageBreak(peserta.indexUrutanPegawai),
                      }" -->
                      <td class="no-border-top no-border-bottom flag-column">
                        <!-- nomor -->
                      </td>
                      <td class="no-border-top no-border-bottom flag-column">
                        <!-- namabulan -->
                      </td>
                      <td
                        class="no-border-right less-padding-right no-border-top no-border-bottom flag-column"
                      >
                        <!-- nodiklat -->
                      </td>
                      <td
                        class="no-border-left less-padding-left no-border-top no-border-bottom flag-column"
                      >
                        <!-- penyelenggara -->
                      </td>
                      <td class="no-border-top no-border-bottom flag-column">
                        <!-- jmlpeserta -->
                      </td>
                      <td
                        style="border: 1px solid #000; min-width: 20px"
                        class="no-border-right less-padding-right"
                      >
                        {{ pesertaIndex + 2 }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        class="no-border-left less-padding-left"
                      >
                        {{ peserta.pegawai.nama }}
                      </td>
                      <td>{{ peserta.jabatan_print }}</td>
                      <td class="no-border-top no-border-bottom flag-column">
                        <!-- ada -->
                      </td>
                      <td class="no-border-top no-border-bottom flag-column">
                        <!-- tidakada -->
                      </td>
                      <td
                        class="no-border-top no-border-right no-border-bottom flag-column"
                      >
                        <!-- rp -->
                      </td>
                      <td
                        class="no-border-top no-border-left no-border-bottom flag-column"
                      >
                        <!-- biaya -->
                      </td>
                      <td class="no-border-top no-border-bottom flag-column">
                        <!-- materi -->
                      </td>
                    </tr>
                  </template>
                </template>

                <!-- <tr>
                  <td
                    colspan="10"
                    style="border: 1px solid #000; padding: 5px"
                    class="center-middle-text"
                  >
                    <div><strong>Total Jumlah</strong></div>
                  </td>
                  <td
                    style="border: 1px solid #000; width: 2px; padding: 5px"
                    class="no-border-right less-padding-right left-middle-text bold-text"
                  >
                    Rp.
                  </td>
                  <td
                    style="border: 1px solid #000; width: 2px; padding: 5px"
                    class="no-border-left less-padding-left right-middle-text bold-text"
                  >
                    {{ formatNumber(diklatsSummary[0]) }}
                  </td>

                  <td></td>
                </tr> -->
              </table>

              <div class="row arial12" v-if="diklats">
                <div class="row" style="text-align: center">
                  <div class="col-6">
                    <br />
                    <br />

                    Diperiksa oleh:<br />
                    <br />

                    <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabat.pejabatMengetahui"
                    >
                      {{ pejabat.pejabatMengetahui.nama }}
                    </div>

                    <div v-if="pejabat.pejabatMengetahui">
                      {{ pejabat.pejabatMengetahui.jabatan }}
                    </div>
                  </div>

                  <div class="col-6">
                    <br />

                    Singaraja, {{ currentTgl }}

                    <br />

                    Dibuat Oleh:<br />
                    <br />

                    <!-- <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabatMembuat"
                    >
                      {{ pejabatMembuat.nama }}
                    </div> -->
                    <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabat.pejabatMembuat"
                    >
                      {{ pejabat.pejabatMembuat.nama }}
                    </div>
                    <div v-if="pejabat.pejabatMembuat">
                      {{ pejabat.pejabatMembuat.jabatan }}
                    </div>
                    <!-- Ka. Sub Bag. Personalia -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /col-12 -->
    </div>
    <!-- /row add-page-break-after  END OF GAJI DIREKSI-->

    <!-- /v-for cabangs END OF KONTRAK-->
  </div>
  <!-- /section-to-print -->
</template>

<style scoped lang="scss">
.bold-text {
  font-weight: bold;
}
.header-title {
  text-align: center;
  font-family: Arial, sans-serif; /* Set font to Arial */
  font-size: 12px;
}
.biaya-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.biaya-symbol {
  text-align: left;
}

.biaya-amount {
  text-align: right;
}

.center-top-text {
  vertical-align: top; /* Align text to the top */
  text-align: center; /* Center text horizontally */
}

.center-middle-text {
  vertical-align: middle; /* Align text to the top */
  text-align: center; /* Center text horizontally */
}

.left-top-text {
  vertical-align: top; /* Align text to the top */
  text-align: left; /* Center text horizontally */
}

.right-top-text {
  vertical-align: top; /* Align text to the top */
  text-align: right; /* Center text horizontally */
}

.left-middle-text {
  vertical-align: middle; /* Align text to the top */
  text-align: left; /* Center text horizontally */
}

.right-middle-text {
  vertical-align: middle; /* Align text to the top */
  text-align: right; /* Center text horizontally */
}

.no-border-right {
  border-right: none !important;
}
.no-border-left {
  border-left: none !important;
}

.no-border-bottom {
  border-bottom: none !important;
}

.no-border-top {
  border-top: none !important;
}

.border-top {
  border-top: 1px solid #000 !important;
}

.table {
  width: 100%;
  border: 1px solid #000; /* Adjust the border thickness as needed */
  border: collapse;
  font-family: Arial, sans-serif; /* Set font to Arial */
  font-size: 10px; /* Set font size to 10 */
}

.table th {
  vertical-align: top; /* Align text to the top */
  min-width: 5px; /* Ensure a minimum width for readability */
  max-width: 500px; /* Ensure a maximum width for readability */
  border: 1px solid #000; /* Adjust the border thickness as needed */
  padding: 4px; /* Adjust this value as needed */
  vertical-align: middle; /* Center align the text vertically */
}

.table td:not(.less-padding):not(.less-padding-left):not(.less-padding-right) {
  vertical-align: top; /* Align text to the top */
  min-width: 5px; /* Ensure a minimum width for readability */
  max-width: 500px; /* Ensure a maximum width for readability */
  border: 1px solid #000; /* Adjust the border thickness as needed */
  padding: 4px; /* Adjust this value as needed */
  vertical-align: top; /* Center align the text vertically */
}

.less-padding {
  vertical-align: top; /* Align text to the top */
  min-width: 5px; /* Ensure a minimum width for readability */
  max-width: 500px; /* Ensure a maximum width for readability */
  border: 1px solid #000; /* Adjust the border thickness as needed */
  padding-top: 4px; /* Adjust this value as needed */
  padding-bottom: 4px; /* Adjust this value as needed */
  padding-left: 0px;
  padding-right: 0px;
  margin: 0px; /* Adjust this value as needed */
  vertical-align: top; /* Center align the text vertically */
}

.less-padding-right {
  vertical-align: top; /* Align text to the top */
  min-width: 5px; /* Ensure a minimum width for readability */
  max-width: 500px; /* Ensure a maximum width for readability */
  border: 1px solid #000; /* Adjust the border thickness as needed */
  padding-top: 4px; /* Adjust this value as needed */
  padding-bottom: 4px; /* Adjust this value as needed */
  padding-left: 4px;
  padding-right: 0px;
  margin: 0px; /* Adjust this value as needed */
  vertical-align: top; /* Center align the text vertically */
}

.less-padding-left {
  vertical-align: top; /* Align text to the top */
  min-width: 5px; /* Ensure a minimum width for readability */
  max-width: 500px; /* Ensure a maximum width for readability */
  border: 1px solid #000; /* Adjust the border thickness as needed */
  padding-top: 4px; /* Adjust this value as needed */
  padding-bottom: 4px; /* Adjust this value as needed */
  padding-left: 0px;
  padding-right: 4px;
  margin: 0px; /* Adjust this value as needed */
  vertical-align: top; /* Center align the text vertically */
}

@media print {
  // table {
  //   width: 100%;
  //   border-collapse: collapse;
  //   page-break-inside: auto;
  //   page-break-after: auto;
  // }
  tr {
    page-break-inside: auto; /* Avoid breaking inside rows */
    page-break-after: auto;
  }
  .border-bottom {
    border-bottom: 1px solid black !important;
  }
  .add-page-break-after {
    page-break-after: always;
  }

  // tbody {
  //   display: table-row-group; /* Allows breaking inside rowspanned rows */
  // }
  // /* Force page breaks after certain rows */
  // .page-break {
  //   page-break-before: always;
  //   break-before: always;
  // }
}
</style>
<script>
// import { useGajiListStore } from "@/stores/views/gaji-list-store";
import axios from "axios";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import angkaTerbilang from "@develoka/angka-terbilang-js";
import _ from "lodash";
import { DateTime } from "luxon";
import { useCommonStore } from "@/stores/utility/common-store2";
import * as commonFunction from "@/utils/common-function.js";
import { useDiklatListStore } from "@/stores/views/diklat-list-store";

let indexTableHonor = 1;
export default {
  // Component logic goes here
  setup() {
    const commonStore = useCommonStore();
    const diklatListStore = useDiklatListStore();
    // const gajiListStore = useGajiListStore();
    return {
      commonStore,
      // gajiListStore,
      commonFunction,
      diklatListStore,
    };
  },
  data() {
    return {
      indexUrutanPegawai: 0,
      tglGaji: this.$route.query.tgl,
      diklats: null,
      diklatsSummary: [],
      currentTgl: this.convertTglIndonesia(
        new Date().toISOString().slice(0, 10),
      ),
      pejabatMengetahui: null,
      pejabatMembuat: null,

      pejabatMenyetujui: null,
      pejabatDirut: null,
      cabangs: null,
      units: null,
      cabangsLength: null,
      bagians: null,
      bidangs: null,
      subBagians: null,
      subBidangs: null,
      seksis: null,
      jabatans: null,
      totalRows: 0,
      previousSubBagianId: null,
      indexHonor: 0,
      indexKontrak: 0,
      indexTableKontrak: 1,
      gajiIndexLength: 0,
      printResults: [], // Array to store the results
      pejabat: null,
    };
  },
  async created() {
    let filter = JSON.parse(decodeURIComponent(this.$route.query.filter));
    console.log("filter query:", filter);

    const lastDate = _.chain([filter])
      .flattenDeep() // 1. Flatten all nested arrays
      .filter((val) => /^\d{4}-\d{2}-\d{2}/.test(val)) // 2. Keep only date strings
      .last() // 3. Get the very last one
      .value();

    const finalDate = _.defaultTo(
      lastDate,
      DateTime.now().startOf("month").toISODate(),
    );
    console.log("Extracted dates:", lastDate);
    // console.log("Extracted dates:", dates.last().value()); //tgl terakhir
    const data = await this.diklatListStore.getData(filter);

    this.diklats = data.data;
    this.diklatsSummary = data.summary;
    await this.commonStore.preloadStores();

    this.pejabat = await this.commonFunction.getPejabatPengesahan(finalDate); //ambil pejabat berdasarkan tgl terakhir di filter
  },
  beforeUnmount() {
    window.removeEventListener("beforeprint", this.handleBeforePrint);
    window.removeEventListener("afterprint", this.handleAfterPrint);
  },

  async mounted() {
    window.addEventListener("beforeprint", this.handleBeforePrint);
    window.addEventListener("afterprint", this.handleAfterPrint);
    this.cabangs = _.sortBy(this.commonStore.cabangStore, ["id"]);

    this.bagians = _.sortBy(
      _.filter(this.commonStore.bagianStore, (item) => item.id !== null),
      ["id"],
    );

    // this.bidangs = _.sortBy(this.commonStore.bidangStore, ["id"]);
    this.bidangs = _.sortBy(
      _.filter(this.commonStore.bidangStore, (item) => item.id !== null),
      ["id"],
    );

    this.units = _.sortBy(
      _.filter(this.commonStore.unitStore, (item) => item.id !== null),
      ["id"],
    );

    this.subBagians = _.sortBy(this.commonStore.subBagianStore, ["order"]);
    this.cabangsLength = this.cabangs.length;

    this.subBidangs = _.sortBy(this.commonStore.subBidangStore, ["order"]);
    this.seksis = _.sortBy(this.commonStore.seksiStore, ["order"]);
    this.jabatans = _.sortBy(this.commonStore.jabatanStore, ["id"]);
    // await this.fetchDataPejabatPembuatGaji();

    this.indexHonor = 0;
  },
  computed: {
    filteredData() {
      const year = new Date(this.diklats[0].tgl).getFullYear();
      const months = Array.from(
        { length: 12 },
        (_, index) => `${year}-${String(index + 1).padStart(2, "0")}`,
      );

      const res = months
        .map((month) => ({
          month,
          ...this.getDataFiltered(month),
        }))
        .filter((data) => data.totalPegawais > 0);

      return res;
    },

    shouldRenderSubBagian() {
      const condition1 = this.subBagians !== null;
      const condition2 = this.subBidangs !== null;
      const condition3 = this.seksis !== null;
      const condition4 = this.jabatans !== null;

      return condition1 && condition2 && condition3 && condition4; //salah satu tidak null
    },
    getGlobalVariable() {
      return indexTableHonor;
    },
    boldStyle() {
      // Define inline styles to make the text bold
      return {
        fontWeight: "bold",
      };
    },
  },

  methods: {
    isPageBreak(pesertaIndex) {
      return (pesertaIndex + 1) % 21 === 0;
      // Assume a page has ~20 rows and mark a break before each new page
      // return (pesertaIndex + 20) % 5 === 0;
    },
    handleBeforePrint() {
      // Find all page-break rows and add a border to the last one on each page
      let rows = document.querySelectorAll("tr");

      rows.forEach((row) => {
        if (row.classList.contains("page-break")) {
          // if (lastRow) {
          //   let nomorCell = lastRow.querySelector(".nomor-column");
          //   if (nomorCell) {
          //     nomorCell.style.borderBottom = "2px solid black";
          //   }
          // }
          // lastRow = row;

          let flagCell = row.querySelectorAll(".flag-column");

          if (flagCell) {
            flagCell.forEach((cell) => {
              cell.classList.remove("no-border-bottom");
              cell.classList.add("border-bottom");
              cell.classList.add("add-page-break-after");
            });
          }
        }
      });
    },
    handleAfterPrint() {
      // Remove the borders after printing
      // document.querySelectorAll(".nomor-column").forEach((cell) => {
      //   cell.style.borderBottom = "none";
      // });
    },

    getDataFiltered(month) {
      const diklatPerMonth = _.filter(this.diklats, (item) => {
        return _.startsWith(item.tgl, month);
      });
      diklatPerMonth.forEach((item) => {
        item.diklat_pegawais.forEach((pegawai) => {
          pegawai.indexUrutanPegawai = this.indexUrutanPegawai++;
        });
      });

      const totalPegawais = _.sumBy(
        diklatPerMonth,
        (item) => item.diklat_pegawais.length,
      );
      return {
        totalPegawais,
        diklatPerMonth,
      };
    },
    incrementIndexTableHonor() {
      indexTableHonor++;
      return indexTableHonor / 2; // This ensures Vue won't interfere with the template rendering
    },
    printGolKontrak(golongan) {
      return golongan ? golongan.charAt(0) : ""; // Return the first character or an empty string if null
    },
    printBulanNama(tgl) {
      const date = DateTime.fromFormat(tgl, "yyyy-M-dd");
      const monthNameIndonesian = date.setLocale("id").toFormat("MMMM");
      // .toUpperCase();
      return monthNameIndonesian;
    },
    printTahun() {
      if (this.diklats.length > 0) {
        let tahunAwal = DateTime.fromFormat(
          this.diklats[0].tgl,
          "yyyy-M-dd",
        ).year;
        let tahunAkhir = DateTime.fromFormat(
          this.diklats[this.diklats.length - 1].tgl,
          "yyyy-M-dd",
        ).year;

        if (tahunAwal === tahunAkhir) {
          return tahunAwal;
        } else {
          return `${tahunAwal} - ${tahunAkhir}`;
        }
      }
    },

    printNewLine(print) {
      if (print)
        return {
          display: "block",
          whiteSpace: "pre-line",
          height: "1em",
        };
      else
        return {
          display: "inline",
        };
    },

    convertTglFormat(tgl) {
      const parsedDate = DateTime.fromISO(tgl);

      // Format the date as "namaHari tanggal Bulan tahun" (Indonesian)
      const formattedDate = parsedDate.setLocale("id").toFormat("d MMMM yyyy");
      return formattedDate;
    },

    isDateFormatYMD(dateString) {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/; // Regular expression for Y-m-d format
      return dateRegex.test(dateString);
    },

    convertTglIndonesia(inputDate) {
      if (!inputDate) return "";
      if (!this.isDateFormatYMD(inputDate)) return "";
      const parsedDate = DateTime.fromISO(inputDate);

      // Format the date in the desired Indonesian format
      const formattedDate = parsedDate.setLocale("id").toLocaleString({
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      return formattedDate;
    },

    async fetchDataPejabatPembuatGaji() {
      try {
        const data = {
          tgl_gaji: this.tglGaji,
        };

        const response = await axios.post(
          `${API_BASE_URL}/pejabat_gaji`,
          data,
          {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "Content-Type": "application/json",
            },
          },
        );

        this.pejabatMengetahui = response.data.kabagUmum.simpeg_pegawai;
        this.pejabatMembuat = response.data.kasubagPersonalia.simpeg_pegawai;
        this.pejabatMenyetujui = response.data.dirum.simpeg_pegawai;
        this.pejabatDirut = response.data.dirut.simpeg_pegawai;

        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    formatNumberTerbilang(value) {
      if (typeof value === "string") {
        value = value.replace(/\./g, "");
      }

      if (value !== null && value !== undefined) {
        // Convert the value to a string and remove the decimal part (".00")
        const stringValue = value.toString().split(".")[0];
        return _.startCase(angkaTerbilang(stringValue));
        // Add thousands separator
        // return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    formatNumber(value) {
      // if (value) {
      //   return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      // }
      // return value;
      if (value !== null && value !== undefined) {
        // Convert the value to a string and remove the decimal part (".00")
        const stringValue = value.toString().split(".")[0];

        // Add thousands separator
        return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return value;
    },

    toUpper(val) {
      return _.toUpper(val);
    },

    getSumsColJml(conditions, gajiTabel, kontrak = false) {
      var filteredItems = this.getFilteredGajis(conditions, gajiTabel);
      var sum = 0;
      filteredItems.forEach((item) => {
        if (kontrak) {
          sum +=
            parseFloat(item.honor_umk_jml) +
            parseFloat(item.kenaikan_masa_kerja) +
            parseFloat(item.tun_kesehatan) -
            parseFloat(item.pot_5_persen);
        } else {
          var numericValue = parseFloat(item.tun_pph);
          var numericValue2 = parseFloat(item.jml_bruto);

          // Check if the numericValue is a valid number (not NaN)
          if (!isNaN(numericValue)) {
            sum += numericValue + numericValue2;
          }
        }
      });
      return this.formatNumber(sum);
    },

    getSums(conditions, gajiTabel, col) {
      var filteredItems = this.getFilteredGajis(conditions, gajiTabel);
      var sum = 0;
      filteredItems.forEach((item) => {
        var numericValue = parseFloat(item[col]);

        // Check if the numericValue is a valid number (not NaN)
        if (!isNaN(numericValue)) {
          sum += numericValue;
        }
      });
      // return sum;
      return this.formatNumber(sum);
    },

    getPageBreakStyle(index) {
      var rowSaatIni = index + 1;

      // if (rowSaatIni === 10)
      //   return "top-text table-row-vfor add-page-break-after"; //page break di tr ke 10
      // if (rowSaatIni % 10 === 0)
      //   return "top-text table-row-vfor add-page-break-before";

      if (rowSaatIni > 13 && (rowSaatIni - 1) % 13 === 0) {
        return "top-text table-row-vfor add-page-break-before"; // Add page break before 11th, 21st, etc.
      }
      return "top-text table-row-vfor";
    },
  },
};
</script>
